import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer} from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(url, args:string) {
    if(url.indexOf("<iframe")>-1){
      let temp=url.split(" ");
      temp.forEach(item=>{
        if(item.indexOf("src=")>-1){
          url = item.split("=")[1].replace(/['"]+/g, '');
        }
      })
    }
    if (args === 'autoPlay') {
      url += "?autoplay=1";
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/directives/safe.pipe.ts